export const Button = {
    baseStyle: {
        borderRadius: 'md',
        fontWeight: '600',
    },
    defaultProps: {
        size: 'lg',
    },
}
